"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uncuratedTableConf = exports.namingTableConf = exports.toolsDetailsTableConf = void 0;
var constants_1 = require("containers/TableMaker/constants");
var SetLogoBtn_1 = __importDefault(require("./CellComponents/SetLogoBtn"));
var MoveToServices_1 = __importDefault(require("./Uncurated/MoveToServices"));
var UncuratedName_1 = __importDefault(require("./Uncurated/UncuratedName"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, XS = constants_1.CellSize.XS;
exports.toolsDetailsTableConf = {
    headersMap: {
        serviceName: 'Tool',
        hasDeals: 'Deals',
        productDescription: 'Oneliner',
    },
    extractors: {
        hasDeals: function (item) { return "".concat(item.hasDeals ? 'true' : 'false'); },
        serviceName: function (s) { return s.niceName || s.name; },
    },
    cells: [
        { field: 'serviceName', cell: { width: XL }, avatar: { size: 'xxs' }, truncate: {} },
        { field: 'hasDeals', cell: { width: LG }, hiddenOnPartial: true },
        { field: 'productDescription', cell: { width: XL, offset: 'right' }, hiddenOnPartial: true, truncate: {} },
        { field: 'description', cell: { width: XL, offset: 'right' }, hiddenOnPartial: true, truncate: {} },
        { key: '_extLogoBtn', cell: { width: XL, offset: 'left' }, hiddenOnPartial: true, renderComponent: SetLogoBtn_1.default },
    ],
};
exports.namingTableConf = {
    headersMap: {
        nameG2: 'G2 Name',
        lastResortMatchExceptions: 'Last Resort Match Exemptions',
    },
    extractors: {
        aliases: function (s) { var _a; return ((_a = s.aliases) === null || _a === void 0 ? void 0 : _a.join(',')) || ''; },
        lastResortMatchExceptions: function (s) { var _a; return ((_a = s.lastResortMatchExceptions) === null || _a === void 0 ? void 0 : _a.join(',')) || ''; },
    },
    cells: [
        {
            cell: { width: XL }, avatar: { size: 'xxs' }, truncate: {}, field: 'name', footerAggregate: 'sum',
        },
        { cell: { width: LG }, field: 'niceName', hiddenOnPartial: true },
        { cell: { width: LG }, field: 'longName', hiddenOnPartial: true, truncate: {} },
        { cell: { width: XL }, field: 'nameG2', hiddenOnPartial: true, truncate: {} },
        { field: 'aliases', cell: { width: LG }, hiddenOnPartial: true, truncate: {} },
        { cell: { width: XL + XS }, field: 'lastResortMatchExceptions', hiddenOnPartial: true, truncate: {} },
    ],
};
exports.uncuratedTableConf = {
    extractors: {
        categoriesList: function (s) { var _a; return ((_a = s.categories) === null || _a === void 0 ? void 0 : _a.join(' • ')) || ''; },
    },
    cells: [
        {
            cell: { width: XL }, field: 'name', renderComponent: UncuratedName_1.default, footerAggregate: 'count',
        },
        { cell: { width: LG }, truncate: {}, field: 'categoriesList' },
        { cell: { width: MD }, field: 'rating' },
        { cell: { width: LG }, field: 'ratingCount' },
        { cell: { width: LG }, key: 'ratingCount', renderComponent: MoveToServices_1.default },
    ],
};
